"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSectionMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _spaceMixin = require("../spaceMixin");
var _spacingMixin = require("../spacingMixin");
/** @class CardSectionMixin */
/** @method */
var CardSectionMixin = function CardSectionMixin(props) {
  return (0, _styledToken.default)({
    borderColor: 'Card.separatorColor',
    paddingBottom: 'Card.section.paddingBottom',
    marginBottom: 'Card.section.marginBottom',
    borderBottomWidth: 'Card.section.borderBottomWidth'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      paddingBottom = _ref.paddingBottom,
      marginBottom = _ref.marginBottom,
      _ref$borderBottomWidt = _ref.borderBottomWidth,
      borderBottomWidth = _ref$borderBottomWidt === void 0 ? 1 : _ref$borderBottomWidt;
    return (0, _styledComponents.css)(["border-bottom:", "px solid ", ";padding-bottom:", ";margin-bottom:", ";&:last-of-type{border-bottom:0;padding-bottom:0;margin-bottom:0;}", ""], borderBottomWidth, borderColor, paddingBottom ? paddingBottom + "px" : (0, _spaceMixin.spaceMixin)('md')(props), marginBottom ? marginBottom + "px" : (0, _spaceMixin.spaceMixin)('md')(props), (0, _spacingMixin.spacingMixin)(props));
  })(props);
};
exports.CardSectionMixin = CardSectionMixin;